﻿import {InstallationId, IPermitsHttpClient} from "@2d-front-monorepo/permits-business";
import {HttpContext} from "../contexts/HttpContext";

export function getHttpClient(installationId?: InstallationId): IPermitsHttpClient {
	return HttpContext.getClient(installationId);
}
